import {i18n} from '@yourcoach/i18n';

import type {ParsedDuration, ProgramDurationUnit} from './types';

import {ProgramDurationUnitEnum} from './programDurationEnum';

const getDurationUnit = (duration: number): ProgramDurationUnit => {
  let result = ProgramDurationUnitEnum.DAY;

  [ProgramDurationUnitEnum.MONTH, ProgramDurationUnitEnum.WEEK].some(
    (unit: ProgramDurationUnit) => {
      if (duration % unit.multiplier === 0) {
        result = unit;

        return true;
      }

      return false;
    },
  );

  return {...result};
};

export const parseDuration = (duration: number): ParsedDuration => {
  const unit = getDurationUnit(duration);
  const num = duration / unit.multiplier;

  return {
    num,
    toString: () =>
      /**
       * @i18n_parser
       * t('shared:program.duration_unit.day', {count: num})
       * t('shared:program.duration_unit.month', {count: num})
       * t('shared:program.duration_unit.week', {count: num})
       */
      `${num} ${i18n.t(`shared:program.duration_unit.${unit.id}`, {
        count: num,
      })}`,
    unit,
  };
};
